// @flow
import styled from 'styled-components';

export default styled.div`
  width: 90%;
  max-width: 960px;
  margin: 0 auto;
`;



// WEBPACK FOOTER //
// ./src/components/container/index.js